export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15167.ad1b74c1.jpg";